<template>
  <section
    v-if="$store.state.events.eventPayoutsStatus === 'loading'
      || $store.state.events.eventStatus === 'loading'"
    class="no-transaction">
    <app-loader
      class="loader"
    />
  </section>
  <section
    v-else-if="payouts && payouts.length
      && (accruals.length || debits.length)"
    class="debt-panel"
  >
    <div v-if="accruals.length" class="debt-list">
      <div class="debt-panel__title">
        {{ $t('CP.theyOweMe') }}:
      </div>
      <debt-item
        v-for="user of accruals"
        :key="`${user.uid}${user.currency || ''}`"
        :user="user"
        :currency="user.currency || eventCurrency"
        :money-amount="user.amount"
        :event-is-original="eventIsOriginal"
        type="accrual"
      />
    </div>
    <div v-if="debits.length" class="debt-list">
      <div class="debt-panel__title">
        {{ $t(`CP.iOweThem_${me.gender || '_M'}`) }}:
      </div>
      <debt-item
        v-for="user of debits"
        :key="user.uid"
        :user="user"
        :currency="eventCurrency"
        :money-amount="user.amount"
        :event-is-original="eventIsOriginal"
        type="debit"
      />
    </div>
  </section>
  <section class="no-transaction" v-else>
    <img src="../../assets/img/sad.svg" alt="" class="no-transaction__img">
    <p class="no-transaction__text">{{ $t('CP.noDebts') }}</p>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import DebtItem from '../DebtItem/DebtItem';
import AppLoader from '../AppLoader/AppLoader';

export default {
  name: 'DebtPanel',
  components: {
    AppLoader,
    DebtItem,
  },
  computed: {
    ...mapState({
      me: (state) => state.user.user,
      currentEvent: (state) => state.events.event,
      payouts: (state) => state.events.payouts,
      eventCurrency: (state) => state.events.eventCurrency || state.user.user.currency,
      eventIsOriginal: (state) => state.events.eventIsOriginal,
    }),
    accruals() {
      try {
        const res = [];
        if (this.payouts) {
          this.payouts.forEach((payout) => {
            const payoutUser = this.getContact(payout.uid);
            if (!Array.isArray(payout.amount)) {
              if (payoutUser && payout.amount > 0) {
                res.push({ ...payoutUser, amount: payout.amount });
              }
            } else if (Array.isArray(payout.amount)) {
              payout.amount.forEach((amount) => {
                if (payoutUser && amount.amount > 0) {
                  res.push({ ...payoutUser, amount: amount.amount, currency: amount.currency });
                }
              });
            }
          });
        }
        return res;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('error in accruals: ', e);
        return [];
      }
    },
    debits() {
      try {
        const res = [];
        if (this.payouts) {
          this.payouts.forEach((payout) => {
            const payoutUser = this.getContact(payout.uid);
            if (!Array.isArray(payout.amount)) {
              if (payoutUser && payout.amount < 0) {
                res.push({ ...payoutUser, amount: payout.amount });
              }
            } else if (Array.isArray(payout.amount)) {
              payout.amount.forEach((amount) => {
                if (payoutUser && amount.amount < 0) {
                  res.push({ ...payoutUser, amount: amount.amount, currency: amount.currency });
                }
              });
            }
          });
        }
        return res;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('error in debits: ', e);
        return [];
      }
    },
  },
  methods: {
    getContact(id) {
      try {
        if (this.currentEvent && this.currentEvent.contacts
          && this.$store.state.user.userContacts) {
          const inEventContacts = this.currentEvent.contacts
            .find((contact) => contact.uid === id);
          const inFriends = this.$store.state.user.userContacts
            .find((contact) => contact.uid === id);
          if (inEventContacts && !inEventContacts.full_name) {
            inEventContacts.full_name = inEventContacts.phone;
          }
          if (inFriends && !inFriends.full_name) {
            inFriends.full_name = inFriends.phone;
          }
          return inEventContacts || inFriends;
        }
        return '';
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('cannot find contact: ', e.message);
        return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .debt-panel {
    padding: 36px 95px 20px;
    margin: 0 0 0px;
    height: calc(100% - 63px);
    min-height: 282px;
    overflow-y: auto;
  }

  .debt-panel__title {
    text-align: left;
    opacity: 0.6;
    height: 30px;
  }

  .debt-list {
    margin: 0 0 22px;
  }
  .no-transaction {
    display: flex;
    justify-content: center;
    height: calc(100% - 63px);
    align-items: center;
  }
  .loader {
    margin: auto;
  }
  .no-transaction__img {
    width: 73px;
    height: 52px;
  }
  .no-transaction__text {
    color: #303F9F;
    opacity: 0.2;
    margin-bottom: 0;
  }
  @media screen and (max-width: $breakpoint-sm){
    .debt-panel {
      height: unset;
      padding: 24px 16px 25vh;
    }
  }
</style>
